<div class="deep-dive-container" *ngIf="loaded">

  <!-- CUSTOM BLACK FILTER BAR -->
  <div class="custom-black-filter-bar">
    <div class="filter-group" *ngFor="let filter of topFilters">
      <span class="filter-label">{{ filter.label }}</span>
      <mat-form-field *ngIf="!isPartNumberFilter(filter)" appearance="outline" class="filter-dropdown">
        <mat-select
          #topFilterSelect
          [multiple]="true"
          [panelClass]="'top-filter-panel'"
          [value]="selectedTopFilters[filter.key]"
          placeholder="Select"
          (selectionChange)="onTopFilterValueChange(filter.key, $event.value)"
          (openedChange)="onTopFilterDropdownToggle(filter, $event)">
          <mat-option
            *ngFor="let opt of filter.options"
            [value]="opt"
            [disabled]="isLockedTopFilterOption(filter.key, opt)"
            [class.locked-top-filter-option]="isLockedTopFilterOption(filter.key, opt)"
            (mousedown)="onTopFilterOptionMouseDown(filter.key, opt, $event, topFilterSelect)">
            {{ opt }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <input
        *ngIf="isPartNumberFilter(filter)"
        class="filter-textbox"
        type="text"
        placeholder="Comma separated"
        [ngModel]="selectedTopFilters[filter.key]"
        (ngModelChange)="onTopFilterValueChange(filter.key, $event)" />
    </div>
  </div>
  
  <!-- TOP LEVEL TAB SWITCHER -->
  <div class="deep-dive-header" *ngIf="activeTab !== 'report-view'">
    <div class="tab-options">
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'column-selection'" 
        (click)="switchTab('column-selection')">
        Column Selection
      </button>
      <button 
        class="tab-btn" 
        [class.active]="activeTab === 'saved-selection'" 
        (click)="switchTab('saved-selection')">
        Saved Selection
      </button>
    </div>
  </div>

  <!-- MAIN CONTENT AREA -->
  <div class="deep-dive-content" *ngIf="activeTab !== 'report-view'">
    
    <!-- ============================================== -->
    <!-- TAB 1: COLUMN SELECTION                        -->
    <!-- ============================================== -->
    <div *ngIf="activeTab === 'column-selection'" class="tab-pane column-selection">
      
      <!-- Field Selector Row -->
      <div class="field-selector-row">
        <div class="field-dropdown-wrapper">
          <div class="field-label">Field</div>
          <mat-form-field appearance="outline" class="custom-dropdown">
            <mat-select
              [(value)]="selectedFieldToAdd"
              placeholder="Select Field"
              (openedChange)="onFieldDropdownOpenedChange($event)">
              <mat-option class="field-search-option" disabled>
                <input
                  class="field-search-input"
                  type="text"
                  placeholder="Search field"
                  [ngModel]="fieldSearchText"
                  (ngModelChange)="onFieldSearchChange($event)"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                />
              </mat-option>
              <mat-option *ngFor="let field of getFilteredAvailableFields()" [value]="field">
                {{ field.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        
        <button mat-raised-button class="action-btn-red" (click)="addColumn()" [disabled]="!selectedFieldToAdd">Add</button>
        <button mat-raised-button class="action-btn-light" (click)="openSaveAsDialog()" [disabled]="selectedColumns.length === 0">Save</button>
      </div>

      <!-- Selected Columns Box -->
      <div class="selected-columns-box" *ngIf="activeTab === 'column-selection'">
        <div class="selected-columns-content" *ngIf="selectedColumns.length > 0; else noSelectedColumns">
          <div class="selected-column-row" *ngFor="let column of selectedColumns; let i = index">
            <span class="selected-column-label">{{ getSelectedColumnLabel(column) }}</span>
            <button
              *ngIf="isColumnEditMode"
              type="button"
              class="column-delete-btn"
              (click)="removeSelectedColumn(i)"
              aria-label="Delete selected option">
              -
            </button>
          </div>
        </div>

        <ng-template #noSelectedColumns>
          <div class="columns-empty-text">No columns selected yet.</div>
        </ng-template>
      </div>

      <div class="selected-columns-actions" *ngIf="activeTab === 'column-selection'">
        <button
          type="button"
          class="edit-columns-btn"
          (click)="toggleColumnEditMode()"
          [disabled]="selectedColumns.length === 0">
          {{ isColumnEditMode ? 'Done' : 'Edit' }}
        </button>
      </div>
    </div>


    <!-- ============================================== -->
    <!-- TAB 2: SAVED SELECTION                         -->
    <!-- ============================================== -->
    <div *ngIf="activeTab === 'saved-selection'" class="tab-pane saved-selection">
      <div class="two-pane-layout">
        
        <!-- Left Pane: Pre-defined Reports -->
        <div class="left-pane">
          <div class="pane-title">Pre-defined Reports</div>
          <ul class="saved-reports-list">
             <li *ngFor="let report of savedReports; let i = index" 
                 (click)="selectReport(report)"
                 [class.selected]="selectedReport === report">
               {{ i + 1 }}. {{ report.name }}
             </li>
          </ul>
        </div>
        
        <!-- Right Pane: Selected Columns List -->
        <div class="right-pane">
          <div class="pane-title">Selected Columns</div>
          <ul class="selected-columns-list" *ngIf="selectedReport">
            <li *ngFor="let col of selectedReport.columns">
              • {{ col }}
            </li>
          </ul>
          
          <div class="bottom-actions">
            <button mat-raised-button class="action-btn-light" (click)="editReport()" [disabled]="!selectedReport || isReportLoadInProgress">Edit</button>
            <button mat-raised-button class="action-btn-red" (click)="loadReport()" [disabled]="!selectedReport || isReportLoadInProgress">
              {{ isReportLoadInProgress ? 'Loading...' : 'Load' }}
            </button>
            <button mat-raised-button class="action-btn-light" (click)="switchTab('column-selection')" [disabled]="isReportLoadInProgress">Cancel</button>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- NAVIGATION BOTTOM FOOTER FOR TABS (EXCEPT REPORT) -->
  <div class="bottom-nav-footer" *ngIf="activeTab !== 'report-view'">
    <button mat-raised-button class="footer-btn" (click)="goBack()">Back</button>
    <button *ngIf="activeTab !== 'saved-selection'" mat-raised-button class="footer-btn" (click)="resetAll()">Reset</button>
  </div>


  <!-- ============================================== -->
  <!-- TAB 3: REPORT VIEW (DATA TABLE)                -->
  <!-- ============================================== -->
  <div *ngIf="activeTab === 'report-view'" class="tab-pane report-view-container">
    
    <!-- Header with Tab Switcher exactly like mockups inside data table wrapper -->
    <div class="report-header-tabs">
      <button class="tab-btn mx-1" (click)="switchTab('column-selection')" [disabled]="isExportInProgress">Column Selection</button>
      <button class="tab-btn mx-1" (click)="switchTab('saved-selection')" [disabled]="isExportInProgress">Saved Selection</button>
    </div>

    <!-- The Actual Table -->
    <div class="report-table-frame" *ngIf="reportData && activeReportColumns.length > 0">
      <div class="table-responsive custom-table-wrapper" #reportTableScroller (scroll)="onReportTableScroll()">
        <table class="table custom-table">
          <thead>
            <tr>
              <th *ngFor="let col of activeReportColumns" #reportHeaderCell>
                {{ col.label }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of pagedReportData">
              <ng-container *ngFor="let col of activeReportColumns">
                <td
                  *ngIf="shouldRenderReportCell(row, col)"
                  [attr.rowspan]="getReportCellRowSpan(row, col)"
                  [ngClass]="{'text-right': col.isNumeric, 'rowspan-centered-cell': !!getReportCellRowSpan(row, col)}">
                  {{ getReportCellValue(row, col) }}
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Grand Total Row (outside table frame and scrollable area) -->
    <div class="grand-total-outside" *ngIf="reportData && activeReportColumns.length > 0 && hasSummaryRow">
      <table
        class="table custom-table grand-total-table"
        [style.width.px]="reportTableContentWidth > 0 ? reportTableContentWidth : null"
        [style.margin-left.px]="-reportTableScrollLeft">
        <colgroup>
          <col
            *ngFor="let _ of activeReportColumns; let i = index"
            [style.width.px]="headerColumnWidths[i] || null" />
        </colgroup>
        <tbody>
          <tr class="grand-total-row">
            <td *ngFor="let col of activeReportColumns; let i = index" 
                [ngClass]="{'text-right': col.isNumeric}" class="font-weight-bold">
              {{ getSummaryValue(col.key, i) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="report-pagination" *ngIf="reportData && reportData.length > 0">
      <button type="button" class="pagination-btn" (click)="goToPreviousPage()" [disabled]="currentPage === 1 || isExportInProgress">
        Previous
      </button>
      <span class="pagination-text">
        Page {{ currentPage }} of {{ totalPages }} ({{ totalRecords || reportData.length }} rows, {{ pageSize }} per page)
      </span>
      <button type="button" class="pagination-btn" (click)="goToNextPage()" [disabled]="currentPage === totalPages || isExportInProgress">
        Next
      </button>
    </div>

    <!-- Footer specific to Report View -->
    <div class="bottom-nav-footer report-footer mt-3">
      <button mat-raised-button class="footer-btn" (click)="goBack()" [disabled]="isExportInProgress">Back</button>
      <button mat-raised-button class="footer-btn" (click)="resetFiltersOnly()" [disabled]="isExportInProgress">Reset</button>
      <button mat-raised-button class="footer-btn-red" (click)="exportReport()" [disabled]="isExportInProgress">
        <span class="btn-loading-content" *ngIf="isExportInProgress; else exportLabelReportView">
          <span class="btn-spinner" aria-hidden="true"></span>
          Exporting...
        </span>
        <ng-template #exportLabelReportView>Export</ng-template>
      </button>
    </div>

  </div>

</div>

<div class="loading-overlay" *ngIf="!loaded">
  Loading...
</div>

<div class="load-popup-overlay" *ngIf="isReportLoadInProgress">
  <div class="load-popup-card">
    <div class="load-spinner" aria-hidden="true"></div>
    <div class="load-popup-text">Loading report. Please wait...</div>
  </div>
</div>

<div class="export-popup-overlay" *ngIf="exportPopupVisible">
  <div class="export-popup-card" role="dialog" aria-modal="true" aria-label="Export Status">
    <div class="export-popup-text">{{ exportPopupMessage }}</div>
    <div class="export-popup-actions">
      <button type="button" class="export-popup-ok-btn" (click)="closeExportPopupAndNavigateToDeepDive()">OK</button>
    </div>
  </div>
</div>
